import React, { useEffect, useState } from "react";
import { v4 as uuidv4 } from 'uuid';
import { FxButtonBase } from "../../fxms/inputs/FxButton";
import { FxLabelBase } from "../../fxms/inputs/FxLabel";
import { FxmsData } from "../../fxms/datas/FxData";
import { FxWindow } from "../../fxms/windows/FxWindows";
import { FxActionBase } from "../../fxms/actions/FxAction";
import { FxTextFieldBase } from "../../fxms/inputs/FxTextField";
import { FxTextAreaBase } from "../../fxms/inputs/FxTextArea";
import { FxFileLink } from "../../fxms/inputs/FxFileLink";
import { FxProgressBar} from "../components/FxProgressBar";
import axios from "axios";
import { toKSTISOString } from "../common/commonMethod";

/*관리자> 공지사항 등록/수정 화면 */
export const UI_Board_CU = (props) => {
  const user = FxmsData.getUser();
  const {attr, onCloseBtnClick} = props;
  const [inputDatas, setInputDatas] = React.useState({
    boardTitle : "",
    boardCnts: "",
    inloNo: "",
    postStrtDate: toKSTISOString(new Date()).split('T')[0], // 오늘 날짜로 초기화
    postFnshDate: toKSTISOString(new Date()).split('T')[0]    // 오늘 날짜로 초기화
  });
  const [selectedData, setSelectedData] = React.useState({});
  const [editableYn, setEditableYn] = React.useState(
    props.name ==="ui-board-detail"? true : false );
  const [selectedFiles, setSelectedFiles] = useState([]);
  const [uploadedFiles, setUploadedFiles] = useState([]);
  const [uploadedSize, setUploadedSize] = useState(0);
  const [fileUploadYn, setFileUploadYn] = useState('N');
  const [uploadedFileKey, setUploadedFileKey] = useState([]);
  const [selectedUploadedFiles, setSelectedUploadedFiles] = useState([]);
  const [fetchBoardInlo, setFetchBoardInlo] = useState([]);
  const refershGridData = props.refershGridData? props.refershGridData: attr.callback;

  // 날짜 형식을 YYYY-MM-DD로 변환하는 함수 추가
  const formatDateToDisplay = (dateString) => {
    if (!dateString) return '';
    return dateString.replace(/(\d{4})(\d{2})(\d{2})/, '$1-$2-$3');
  };

  useEffect(() => {    
    console.log("UI_Board_CU", props); 
    getBoardInlo();
    if(editableYn){
      // 상세보기 모드일 때 날짜 형식 변환
      const formattedData = {
        ...props.selectedData,
        postStrtDate: formatDateToDisplay(props.selectedData.postStrtDate),
        postFnshDate: formatDateToDisplay(props.selectedData.postFnshDate)
      };
      setSelectedUploadedFiles(props.selectedData.files);
      setSelectedData(formattedData);
      setInputDatas(formattedData);
      setUploadedFiles(props.selectedData.files);
    } else if (!props.selectedData?.boardNo && !inputDatas.boardTitle){  // 조건 수정
      // 수정 모드가 아니고 새로운 등록일 경우에만 오늘 날짜로 초기화
      const todayStr = toKSTISOString(new Date());
      setInputDatas(prev => ({
        ...prev,
        postStrtDate: todayStr,
        postFnshDate: todayStr
      }));
    }    
  
  }, []);

  const getBoardInlo = async () => {
    const uri = "fxCmBoard/inloList"
    try {
        const res = await FxmsData.GET(uri);
        // FxSelectBase가 이해할 수 있는 형식으로 데이터 변환
        const formattedData = res.data.map(item => ({
          key: item.inloNo,    // select의 value로 사용될 값
          text: item.inloName  // select에 표시될 텍스트
        }));
        setFetchBoardInlo(formattedData);
    } catch (e) {
        console.log("getBoardInlo error ........", e);
    }
  }

  function onChangeValue(id, value) {
    let newData = { ...inputDatas };

    if (value) {
      newData[id] = value;
    } else {
      delete newData[id];
    }
    setInputDatas(newData);
  }
  

  const formatDate = (dateString) => {
    return dateString.replace(/-/g, '');
  };

  const onRegister = async() => { 

    // 기존 파일들의 fileId 배열 생성
    const existingFileIds = uploadedFiles
    .filter(file => file.fileId)
    .map(file => file.fileId);

    // 새로 업로드된 파일 키와 기존 파일 ID를 합침
    const allFileKeys = [...existingFileIds, ...uploadedFileKey];

    if(allFileKeys.length > 0) {
      inputDatas.fileKeys = allFileKeys;
    }

    if(selectedFiles.length !==0 && fileUploadYn==='N') {
      FxWindow.alert("파일업로드를 해주세요", true) 
      return;      
    } 
    
    if(!validation(inputDatas)) return;
    
      // 날짜 형식 변환
    const formattedData = {
      ...inputDatas,
      postStrtDate: formatDate(inputDatas.postStrtDate),
      postFnshDate: formatDate(inputDatas.postFnshDate)
    };
    // 추가

    if (formattedData.boardNo) {
      let caller = new FxActionBase("fxCmBoard/"+formattedData.boardNo, "PUT");
      caller.execute(formattedData, function (bret) {
        onCloseBtnClick();                    
        refershGridData();
      });   
    } else {
      let caller = new FxActionBase("fxCmBoard", "POST");
      caller.execute(formattedData, function (bret) {
        onCloseBtnClick();                    
        refershGridData();
      });        
    }
  }

  const deleteBoard = async() => {
    let caller = new FxActionBase("fxCmBoard/"+selectedData.boardNo, "DELETE");
    caller.execute(selectedData.boardNo, function (bret) {
      onCloseBtnClick();                    
      refershGridData();
    });
  };

  const onUpdate = () => { 
    // 수정 모드로 전환하기 전에 파일 관련 상태 초기화
    setSelectedFiles([]);
    setUploadedFiles(selectedUploadedFiles || []);
    setUploadedSize(0);
    setFileUploadYn('N');
    setUploadedFileKey([]);

    // 기존 데이터를 유지하면서 select 컴포넌트용 데이터 추가
    const updatedData = {
      ...selectedData,
      inloNo: selectedData.inloNo,  // 기존 inloNo 유지
      inloName: selectedData.inloName  // 기존 inloName 유지
    };
    
    setInputDatas(updatedData);
    setSelectedData(updatedData);

    // 수정 모드로 전환
    setEditableYn(false);
  }

  const onDelete = (item) => {
    console.log(item)
    const files = Array.from(selectedFiles).filter((f) => f !== item)
    setUploadedSize(uploadedSize-item.size);
    setSelectedFiles(files);
  }

 const onFileUpload = async (e) => {
  
    if(selectedFiles.length===0) {
      FxWindow.alert("선택한 파일이 없습니다.", true);
      return;
    }

    const formData = new FormData();

    for (let i = 0; i < selectedFiles.length; i++) {
      formData.append('files', selectedFiles[i]);
    }

    console.log(Array.from(formData));

    let dataSet = {
      url: "board",
      delYn: "N"  // DEL_YN 필드 추가
    };

    const json = JSON.stringify(dataSet);
    const blob = new Blob([json], { type: "application/json" });
    formData.append("data", blob);

    try {
      const response = await axios({
        method: "POST",
        url: "/api/open/upload",
        mode: "cors",
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: "Bearer " + localStorage.getItem("token"),
        },
        data: formData,
      });
  
      console.log('파일 업로드 : ', response.data);
      setFileUploadYn('Y');
      setUploadedFiles([...uploadedFiles, ...Array.from(selectedFiles)])
      setSelectedFiles([]);
      // response.data가 배열이 아닌 경우 배열로 변환
      const fileKeys = Array.isArray(response.data) ? response.data : [response.data];
      setUploadedFileKey(prevKeys => [...prevKeys, ...fileKeys]);
      FxWindow.alert("파일업로드가 완료되었습니다.");

      } catch (error) {
        console.error('파일 업로드 실패:', error);
        FxWindow.alert("파일 업로드에 실패했습니다.", true);
      }
     };

  const handleFileChange = (e) => {  
    const files = e.target.files;
    
    if (!files || files.length === 0) {
        setUploadedSize(0);
        setSelectedFiles([]);
        return;
    }

    const limitsize = 1024 ** 2 * 10; // 10MB    
    
    // 새로운 파일들의 총 크기 계산
    const newFilesSize = Array.from(files).reduce((total, file) => {
        return total + file.size;
    }, 0);

    const totalSize = uploadedSize + newFilesSize;

    // 전체 파일 크기가 제한을 초과하는지 확인
    if (totalSize > limitsize) {
        FxWindow.alert("전체 첨부파일의 용량이 10MB를 초과했습니다.", true);
        e.target.value = ''; // 파일 선택 초기화
        return;
    }

    setUploadedSize(totalSize);
    setSelectedFiles(prevFiles => [...Array.from(prevFiles), ...Array.from(files)]);
  }

  const validation = (inputDatas) =>{

    if(inputDatas.boardTitle==="") {
       FxWindow.alert("제목을 입력해주세요" , true) ;
       return false;
    }
    if(inputDatas.boardCnts==="") {
       FxWindow.alert("내용을 입력해주세요" , true) ;
       return false;
    }

    if(inputDatas.inloNo==="") {
      FxWindow.alert("공지 대상을 선택해주세요" , true) ;
      return false;
   }

    return true;

  }

  const handleSelectData = (e) => {
    const { name, value } = e.target;
    setSelectedData({ ...selectedData, [name]: value });
  };

  return (
    <div>
      <div className="FxDataEdit">
        <table className="table">
          <colgroup>
            <col style={{ width: '100px' }} />
            <col style={{ width: '600px' }} />
          </colgroup>
          <tr>
            <th><FxLabelBase>제목</FxLabelBase></th>
            <td><FxTextFieldBase name="boardTitle" onChangeValue={onChangeValue} selectedData={selectedData} disabled={editableYn}  />
            </td>
          </tr>
          <tr>
            <th><FxLabelBase>내용</FxLabelBase></th>
            <td> 
            <FxTextAreaBase name="boardCnts" onChangeValue={onChangeValue} selectedData={selectedData} disabled={editableYn} />
            </td>
          </tr>
          <tr>
            <th><FxLabelBase>공지 대상</FxLabelBase></th>
            { editableYn?
            <td> 
              <select disabled={true} className="FxSelectSearch" value={selectedData.inloNo}>
                <option value={selectedData.inloNo}> 
                  {selectedData.inloName}
                </option>
              </select>
            </td>
            :
            <td> 
              <select 
                className="FxSelectSearch"
                name="inloNo"                
                onChange={(e) => {
                  onChangeValue('inloNo', e.target.value);
                  handleSelectData(e);
                }}
                value={inputDatas.inloNo || ''} // 기존 선택값 유지
              >
                <option value="">대상을 선택하세요</option>
                {fetchBoardInlo.map((item) => (
                  <option key={item.key} value={item.key} name="inloNo">
                    {item.text}
                  </option>
                ))}
              </select>
            </td>
           }      
          </tr>
          <tr>
            <th><FxLabelBase>공지 기간</FxLabelBase></th>
            <td style={{ display: 'flex', alignItems: 'center', gap: '8px' }}> 
              <input 
                className="FxDate" 
                type="date" 
                name="postStrtDate"
                value={inputDatas.postStrtDate || ''} 
                onChange={(e) => {
                  onChangeValue('postStrtDate', e.target.value);
                  handleSelectData(e);
                }}
                disabled={editableYn}
                style={{ width: '150px' }}
              />
              <span style={{ margin: '0 4px' }}>~</span>
              <input 
                className="FxDate" 
                type="date" 
                name="postFnshDate" 
                value={inputDatas.postFnshDate || ''}
                onChange={(e) => {
                  onChangeValue('postFnshDate', e.target.value);
                  handleSelectData(e);
                }}
                disabled={editableYn}
                style={{ width: '150px' }}
              />
            </td>
          </tr>
          {editableYn ?
            <tr>
              <th><FxLabelBase>첨부</FxLabelBase></th>
              <td>
                {selectedUploadedFiles?.map((item)=> (
                    <span key={item.fileId}> <FxFileLink fileId={item.fileId} fileUrl={'Board'} orgNm={item.name}></FxFileLink> </span>
              ))}
              </td>
            </tr> 
            : 
            <tr>
              <th rowSpan='2'><FxLabelBase>첨부</FxLabelBase></th>
              <td>
                <div className="VupFileUpWrap">
                  <input
                    id="fileUp"
                    className='file-input'
                    type="file"                 
                    onChange={handleFileChange}
                    multiple="multiple"
                    disabled={editableYn}
                  />
                  <div className="fileInput"> </div>
                  <button >파일선택</button>  

                </div>
                <FxProgressBar percent={uploadedSize/ (1024 ** 2  * 10) * 100} baseNum={1024 ** 2 * 10}/> 
                <ul className="VupFileUpList">
                  {(uploadedFiles || [])?.map((item) => (
                    <li className="fin" key={item.fileId || uuidv4()}>
                      <span>{item.name}</span>
                    </li>
                  ))}
                  {(Array.from(selectedFiles || []))?.map((item) => (
                    <li key={uuidv4()}>
                      {item.name}
                      <button onClick={() => onDelete(item)}> </button>
                    </li>
                  ))}
                </ul>
                <ul className="VupFileUpNotice">
                    <li>첨부한 파일의 전체 크기는 10Mbyte 미만이어야 합니다.</li>
                    <li>용량이 초과될 경우, 문의 접수가 원활하게 진행되지 않을 수 있습니다.</li>
                    <li>파일첨부는 JPG, GIF, PSD, TIF, MS Office 파일, 아래한글, PDF만 가능합니다.</li>
                </ul>
              </td>
            </tr>}
        </table>
      </div>
      <div className="FxCrudToolbar">
        <div className="FxFilterLeft">
        </div>
        <div className="FxFilterRight">      
          { editableYn? 
            <>
              {user.ugrpNo === 1020 &&<FxButtonBase key={uuidv4()} name="click" onClick={onUpdate} text="수정" />}
              {user.ugrpNo === 1020 &&<FxButtonBase key={uuidv4()} name="click" onClick={deleteBoard} text="삭제" />}
            </>
            : 
            <>
              <FxButtonBase key={uuidv4()} name="click" onClick={onFileUpload} text="파일 업로드" />
              <FxButtonBase key={uuidv4()} name="click" onClick={onRegister} text="등록" />
            </>
            }
        </div>
        
      </div>
    </div>
  )
}
